export const fetchTopPerformers = async (teamId = 111) => {
  const year = new Date().getFullYear();
  const [rosterRes, statsRes] = await Promise.all([
    fetch(`https://statsapi.mlb.com/api/v1/teams/${teamId}/roster?rosterType=active`),
    fetch(`https://statsapi.mlb.com/api/v1/teams/${teamId}/stats?stats=season&group=hitting,pitching&season=${year}`),
  ]);
  const roster = rosterRes.ok ? await rosterRes.json() : null;
  const stats = statsRes.ok ? await statsRes.json() : null;
  return { roster, stats };
};

export const fetchPlayerGameLogs = async (playerIds) => {
  const year = new Date().getFullYear();
  const results = await Promise.all(
    playerIds.map((id) =>
      fetch(`https://statsapi.mlb.com/api/v1/people/${id}/stats?stats=gameLog&group=hitting,pitching&season=${year}&limit=15`)
        .then((r) => (r.ok ? r.json() : null))
        .then((data) => ({ id, data }))
        .catch(() => ({ id, data: null }))
    )
  );
  return results;
};

export const fetchLeaderboards = async (teamId = 111) => {
  const year = new Date().getFullYear();

  // Fetch each category individually to ensure we get proper leaderCategory keys back
  // Note: RBI must use 'runsBattedIn' for the MLB API to recognize it
  const [hrRes, avgRes, rbiRes, sbRes, opsRes, eraRes, kRes, wRes, svRes, whipRes] =
    await Promise.all([
      fetch(`https://statsapi.mlb.com/api/v1/stats/leaders?leaderCategories=homeRuns&teamId=${teamId}&season=${year}&limit=10&statGroup=hitting`),
      fetch(`https://statsapi.mlb.com/api/v1/stats/leaders?leaderCategories=battingAverage&teamId=${teamId}&season=${year}&limit=10&statGroup=hitting`),
      fetch(`https://statsapi.mlb.com/api/v1/stats/leaders?leaderCategories=runsBattedIn&teamId=${teamId}&season=${year}&limit=10&statGroup=hitting`),
      fetch(`https://statsapi.mlb.com/api/v1/stats/leaders?leaderCategories=stolenBases&teamId=${teamId}&season=${year}&limit=10&statGroup=hitting`),
      fetch(`https://statsapi.mlb.com/api/v1/stats/leaders?leaderCategories=onBasePlusSlugging&teamId=${teamId}&season=${year}&limit=10&statGroup=hitting`),
      fetch(`https://statsapi.mlb.com/api/v1/stats/leaders?leaderCategories=era&teamId=${teamId}&season=${year}&limit=10&statGroup=pitching`),
      fetch(`https://statsapi.mlb.com/api/v1/stats/leaders?leaderCategories=strikeouts&teamId=${teamId}&season=${year}&limit=10&statGroup=pitching`),
      fetch(`https://statsapi.mlb.com/api/v1/stats/leaders?leaderCategories=wins&teamId=${teamId}&season=${year}&limit=10&statGroup=pitching`),
      fetch(`https://statsapi.mlb.com/api/v1/stats/leaders?leaderCategories=saves&teamId=${teamId}&season=${year}&limit=10&statGroup=pitching`),
      fetch(`https://statsapi.mlb.com/api/v1/stats/leaders?leaderCategories=whip&teamId=${teamId}&season=${year}&limit=10&statGroup=pitching`),
    ]);

  const parseRes = async (res) => {
    if (!res.ok) return null;
    const json = await res.json();
    return json?.leagueLeaders?.[0] || null;
  };

  const [hr, avg, rbi, sb, ops, era, k, w, sv, whip] = await Promise.all([
    parseRes(hrRes),
    parseRes(avgRes),
    parseRes(rbiRes),
    parseRes(sbRes),
    parseRes(opsRes),
    parseRes(eraRes),
    parseRes(kRes),
    parseRes(wRes),
    parseRes(svRes),
    parseRes(whipRes),
  ]);

  const battingLeaders = [hr, avg, rbi, sb, ops].filter(Boolean);
  const pitchingLeaders = [era, k, w, sv, whip].filter(Boolean);

  return {
    batting: { leagueLeaders: battingLeaders },
    pitching: { leagueLeaders: pitchingLeaders },
  };
};